<template>
    <div style="display:flex; flex-direction:column; justify-content:center; align-items:center;">
      <Header></Header>
      <HeaderSec Title="云与基础设施" Desc="" :BreadcrumbList="BreadcrumbList"></HeaderSec>
      <div class="list"><Divider orientation="left">超融合一体机</Divider></div>
      <Row style="padding:20px;" gutter="24" class="list">
          <Col :xs="24" :sm="24" :md="10" :lg="6" :xl="6" :xxl="6">
            <Card class="blueiaas-card">
              <Typography>
                <Image src="https://www.bluehci.com/images001/server001.png" fit="contain" width="270px" height="161px" alt="contain" />
                <Paragraph>
                  <Text style="padding: 3px 6px 3px 6px; background-color:rgb(252, 186, 2); color:#333;">传统应用优选</Text>
                </Paragraph>
                <Title :level="5"><router-link to="Blueiaas-LX5-HL101">超融合节点 LX5-HL101</router-link></Title>
                <Paragraph>
                  Intel® 至强 金牌6134 3.2GHz 8C * 2 <br />
                  <Text>轻量高效，可靠稳定，售价 </Text>
                  <Numeral :value="Price['LX5-HL101'][0]" format="0,0.00" style="font-weight: 600;">
                      <template #prefix>
                          <strong>¥</strong>
                      </template>
                  </Numeral> 起
                </Paragraph>
              </Typography>
            </Card>
          </Col>
          <Col :xs="24" :sm="24" :md="10" :lg="6" :xl="6" :xxl="6">
            <Card class="blueiaas-card">
              <Typography>
                <Image src="https://www.bluehci.com/images001/server001.png" fit="contain" width="270px" height="161px" alt="contain" />
                <Paragraph>
                  <Text style="padding: 3px 6px 3px 6px; background-color:rgb(252, 186, 2); color:#333;">互联网应用优选</Text>
                </Paragraph>
                <Title :level="5"><router-link to="Blueiaas-LX5-HS101">超融合节点 LX5-HS101</router-link></Title>
                <Paragraph>
                  Intel® 至强 金牌6138 2.0GHz 20C * 2 <br />
                  <Text>多核并发，极高性价比，售价 </Text>
                  <Numeral :value="Price['LX5-HS101'][0]" format="0,0.00" style="font-weight: 600;">
                      <template #prefix>
                          <strong>¥</strong>
                      </template>
                  </Numeral> 起
                </Paragraph>
              </Typography>
            </Card>
          </Col>
          <Col :xs="24" :sm="24" :md="10" :lg="6" :xl="6" :xxl="6">
            <Card class="blueiaas-card">
              <Typography>
                <Image src="https://www.bluehci.com/images001/server001.png" fit="contain" width="270px" height="161px" alt="contain" />
                <Paragraph>
                  <Text style="padding: 3px 6px 3px 6px; background-color:rgb(252, 186, 2); color:#333;">传统应用优选</Text>
                </Paragraph>
                <Title :level="5"><router-link to="Blueiaas-LX5-HL302">超融合节点 LX5-HL302</router-link></Title>
                <Paragraph>
                  Intel® 至强 金牌6254 3.1GHz 18C * 2<br />
                  <Text>高频处理，澎湃动力，售价  </Text>
                  <Numeral :value="Price['LX5-HL302'][0]" format="0,0.00" style="font-weight: 600;">
                      <template #prefix>
                          <strong>¥</strong>
                      </template>
                  </Numeral> 起
                </Paragraph>
              </Typography>
            </Card>
          </Col>
          <Col :xs="24" :sm="24" :md="10" :lg="6" :xl="6" :xxl="6">
            <Card class="blueiaas-card">
              <Typography>
                <Image src="https://www.bluehci.com/images001/server001.png" fit="contain" width="270px" height="161px" alt="contain" />
                <Paragraph>
                  <Text style="padding: 3px 6px 3px 6px; background-color:rgb(252, 186, 2); color:#333;">互联网应用优选</Text>
                </Paragraph>
                <Title :level="5"><router-link to="Blueiaas-LX5-HS302">超融合节点 LX5-HS302</router-link></Title>
                <Paragraph>
                  Intel® 至强 金牌6230R 2.1GHz 26C * 2 <br />
                  <Text>主打多核，线程为王，售价 </Text>
                  <Numeral :value="Price['LX5-HS302'][0]" format="0,0.00" style="font-weight: 600;">
                      <template #prefix>
                          <strong>¥</strong>
                      </template>
                  </Numeral> 起
                </Paragraph>
              </Typography>
            </Card>
          </Col>
          <Col :xs="24" :sm="24" :md="10" :lg="6" :xl="6" :xxl="6">
            <Card class="blueiaas-card">
              <Typography>
                <Image src="https://www.bluehci.com/images001/server001.png" fit="contain" width="270px" height="161px" alt="contain" />
                <Paragraph>
                  <Text style="padding: 3px 6px 3px 6px; background-color:rgb(252, 186, 2); color:#333;">全面适应</Text>
                </Paragraph>
                <Title :level="5"><router-link to="Blueiaas-LX5-HP302">超融合节点 LX5-HP302</router-link></Title>
                <Paragraph>
                  Intel® 至强 金牌6248R 3.0GHz 24C * 2 <br />
                  <Text>高频多核，鱼熊兼得，售价 </Text>
                  <Numeral :value="Price['LX5-HP302'][0]" format="0,0.00" style="font-weight: 600;">
                      <template #prefix>
                          <strong>¥</strong>
                      </template>
                  </Numeral> 起
                </Paragraph>
              </Typography>
            </Card>
          </Col>
          <Col :xs="24" :sm="24" :md="10" :lg="6" :xl="6" :xxl="6">
            <Card class="blueiaas-card">
              <Typography>
                <Image src="https://www.bluehci.com/images001/server001.png" fit="contain" width="270px" height="161px" alt="contain" />
                <Paragraph>
                  <Text style="padding: 3px 6px 3px 6px; background-color:rgb(252, 186, 2); color:#333;">传统应用优选</Text>
                </Paragraph>
                <Title :level="5"><router-link to="Blueiaas-LX5-HL303">超融合节点 LX5-HL303</router-link></Title>
                <Paragraph>
                  Intel® 至强 金牌6346 3.1GHz 16C * 2 <br />
                  <Text>高频处理，澎湃动力，售价 </Text>
                  <Numeral :value="Price['LX5-HL303'][0]" format="0,0.00" style="font-weight: 600;">
                      <template #prefix>
                          <strong>¥</strong>
                      </template>
                  </Numeral> 起>
                </Paragraph>
              </Typography>
            </Card>
          </Col>
          <Col :xs="24" :sm="24" :md="10" :lg="6" :xl="6" :xxl="6">
            <Card class="blueiaas-card">
              <Typography>
                <Image src="https://www.bluehci.com/images001/server001.png" fit="contain" width="270px" height="161px" alt="contain" />
                <Paragraph>
                  <Text style="padding: 3px 6px 3px 6px; background-color:rgb(252, 186, 2); color:#333;">互联网应用优选</Text>
                </Paragraph>
                <Title :level="5"><router-link to="Blueiaas-LX5-HS303">超融合节点 LX5-HS303</router-link></Title>
                <Paragraph>
                  Intel® 至强 金牌6330 2.0GHz 28C * 2 <br />
                  <Text>主打多核，线程为王，售价 </Text>
                  <Numeral :value="Price['LX5-HS303'][0]" format="0,0.00" style="font-weight: 600;">
                      <template #prefix>
                          <strong>¥</strong>
                      </template>
                  </Numeral> 起>
                </Paragraph>
              </Typography>
            </Card>
          </Col>
          <Col :xs="24" :sm="24" :md="10" :lg="6" :xl="6" :xxl="6">
            <Card class="blueiaas-card">
              <Typography>
                <Image src="https://www.bluehci.com/images001/server001.png" fit="contain" width="270px" height="161px" alt="contain" />
                <Paragraph>
                  <Text style="padding: 3px 6px 3px 6px; background-color:rgb(252, 186, 2); color:#333;">全面适应</Text>
                </Paragraph>
                <Title :level="5"><router-link to="Blueiaas-LX5-HP303">超融合节点 LX5-HP303</router-link></Title>
                <Paragraph>
                  Intel® 至强 金牌6348 2.6GHz 28C * 2 <br />
                  <Text>多核高频，鱼熊兼得，售价 </Text>
                  <Numeral :value="Price['LX5-HP303'][0]" format="0,0.00" style="font-weight: 600;">
                      <template #prefix>
                          <strong>¥</strong>
                      </template>
                  </Numeral> 起>
                </Paragraph>
              </Typography>
            </Card>
          </Col>
      </Row>
      <div class="list"><Divider orientation="left">裸金属一体机</Divider></div>
      <Row style="padding:20px;" gutter="24" class="list">
        <Col :xs="24" :sm="24" :md="10" :lg="6" :xl="6" :xxl="6">
            <Card class="blueiaas-card">
              <Typography>
                <Image src="https://www.bluehci.com/images001/server001.png" fit="contain" width="270px" height="161px" alt="contain" />
                <Paragraph>
                  <Text style="padding: 3px 6px 3px 6px; background-color:rgb(252, 186, 2); color:#333;">传统应用优选</Text>
                </Paragraph>
                <Title :level="5"><router-link to="Blueiaas-LX5-ML021">裸金属节点 LX5-ML021</router-link></Title>
                <Paragraph>
                  Intel® 至强 金牌6134 3.2GHz 8C * 2 <br />
                  <Text>性能直通，高效IO，售价 </Text>
                  <Numeral :value="Price['LX5-ML021'][0]" format="0,0.00" style="font-weight: 600;">
                      <template #prefix>
                          <strong>¥</strong>
                      </template>
                  </Numeral> 起
                </Paragraph>
              </Typography>
            </Card>
          </Col>
          <Col :xs="24" :sm="24" :md="10" :lg="6" :xl="6" :xxl="6">
            <Card class="blueiaas-card">
              <Typography>
                <Image src="https://www.bluehci.com/images001/server001.png" fit="contain" width="270px" height="161px" alt="contain" />
                <Paragraph>
                  <Text style="padding: 3px 6px 3px 6px; background-color:rgb(252, 186, 2); color:#333;">全面适应</Text>
                </Paragraph>
                <Title :level="5"><router-link to="Blueiaas-LX5-ML022">裸金属节点 LX5-ML022</router-link></Title>
                <Paragraph>
                  Intel® 至强 金牌6254 3.1GHz 18C * 2 <br />
                  <Text>性能直通，高效IO，售价 </Text>
                  <Numeral :value="Price['LX5-ML022'][0]" format="0,0.00" style="font-weight: 600;">
                      <template #prefix>
                          <strong>¥</strong>
                      </template>
                  </Numeral> 起
                </Paragraph>
              </Typography>
            </Card>
          </Col>
          <Col :xs="24" :sm="24" :md="10" :lg="6" :xl="6" :xxl="6">
            <Card class="blueiaas-card">
              <Typography>
                <Image src="https://www.bluehci.com/images001/server001.png" fit="contain" width="270px" height="161px" alt="contain" />
                <Paragraph>
                  <Text style="padding: 3px 6px 3px 6px; background-color:rgb(252, 186, 2); color:#333;">全面适应</Text>
                </Paragraph>
                <Title :level="5"><router-link to="Blueiaas-LX5-MP022">裸金属节点 LX5-MP022</router-link></Title>
                <Paragraph>
                  Intel® 至强 金牌6248R 3.0GHz 24C * 2 <br />
                  <Text>多核高频，鱼熊兼顾，售价 </Text>
                  <Numeral :value="Price['LX5-MP022'][0]" format="0,0.00" style="font-weight: 600;">
                      <template #prefix>
                          <strong>¥</strong>
                      </template>
                  </Numeral> 起
                </Paragraph>
              </Typography>
            </Card>
          </Col>
          <Col :xs="24" :sm="24" :md="10" :lg="6" :xl="6" :xxl="6">
            <Card class="blueiaas-card">
              <Typography>
                <Image src="https://www.bluehci.com/images001/server001.png" fit="contain" width="270px" height="161px" alt="contain" />
                <Paragraph>
                  <Text style="padding: 3px 6px 3px 6px; background-color:rgb(252, 186, 2); color:#333;">全面适应</Text>
                </Paragraph>
                <Title :level="5"><router-link to="Blueiaas-LX5-ML023">裸金属节点 LX5-ML023</router-link></Title>
                <Paragraph>
                  Intel® 至强 金牌6346 3.1GHz 16C * 2 <br />
                  <Text>性能直通，高效IO，售价 </Text>
                  <Numeral :value="Price['LX5-ML023'][0]" format="0,0.00" style="font-weight: 600;">
                      <template #prefix>
                          <strong>¥</strong>
                      </template>
                  </Numeral> 起>
                </Paragraph>
              </Typography>
            </Card>
          </Col>
          <Col :xs="24" :sm="24" :md="10" :lg="6" :xl="6" :xxl="6">
            <Card class="blueiaas-card">
              <Typography>
                <Image src="https://www.bluehci.com/images001/server006.png" fit="contain" width="270px" height="161px" alt="contain" />
                <Paragraph>
                  <Text style="padding: 3px 6px 3px 6px; background-color:rgb(252, 186, 2); color:#333;">传统应用优选</Text>
                </Paragraph>
                <Title :level="5"><router-link to="Blueiaas-LX5-ML011">裸金属节点 LX5-ML011</router-link></Title>
                <Paragraph>
                  Intel® 至强 2680V4 2.4GHz 14C <br />
                  <Text>性能强劲，超高性价比，售价 </Text>
                  <Numeral :value="Price['LX5-ML011'][0]" format="0,0.00" style="font-weight: 600;">
                      <template #prefix>
                          <strong>¥</strong>
                      </template>
                  </Numeral> 起
                </Paragraph>
              </Typography>
            </Card>
        </Col>
      </Row>
      <div class="list"><Divider orientation="left">超融合授权</Divider></div>
      <Row style="padding:20px;" gutter="24" class="list">
          <Col :xs="24" :sm="24" :md="10" :lg="6" :xl="6" :xxl="6">
            <Card class="blueiaas-card">
              <Typography>
                <Icon type="ios-ribbon" size="88"/>
                <Paragraph>
                  <Text style="padding: 3px 6px 3px 6px; background-color:rgb(252, 186, 2); color:#333;">轻量</Text>
                </Paragraph>
                <Title :level="5">超融合授权-三合一版</Title>
                <Paragraph>
                  <Text>简单可靠，轻松入门，售价 </Text>
                  <Numeral value="4000" format="0,0.00" style="font-weight: 600;">
                      <template #prefix>
                          <strong>¥</strong>
                      </template>
                  </Numeral>/CPU
                </Paragraph>
                <Paragraph>
                  <Text>单机虚拟化版本，不含集群和高可用的功能，包含三个云主机和对应的自动快照授权</Text>
                </Paragraph>
              </Typography>
            </Card>
          </Col>
          <Col :xs="24" :sm="24" :md="10" :lg="6" :xl="6" :xxl="6">
            <Card class="blueiaas-card">
              <Typography>
                <Icon type="ios-ribbon" size="88"/>
                <Paragraph>
                  <Text style="padding: 3px 6px 3px 6px; background-color:rgb(252, 186, 2); color:#333;">集群</Text>
                </Paragraph>
                <Title :level="5">超融合授权-标准版</Title>
                <Paragraph>
                  <Text>云化集群，扩容无忧，售价 </Text>
                  <Numeral value="12000" format="0,0.00" style="font-weight: 600;">
                      <template #prefix>
                          <strong>¥</strong>
                      </template>
                  </Numeral>/CPU
                </Paragraph>
                <Paragraph>
                  <Text>集群版本，含完整的虚拟化和集群的功能授权，可以纳管三合一版本的超融合节点</Text>
                </Paragraph>
              </Typography>
            </Card>
          </Col>
          <Col :xs="24" :sm="24" :md="10" :lg="6" :xl="6" :xxl="6">
            <Card class="blueiaas-card">
              <Typography>
                <Icon type="ios-ribbon" size="88"/>
                <Paragraph>
                  <Text style="padding: 3px 6px 3px 6px; background-color:rgb(252, 186, 2); color:#333;">高可用</Text>
                </Paragraph>
                <Title :level="5">超融合授权-高可用版</Title>
                <Paragraph>
                  <Text>数据可靠，系统无忧，售价 </Text>
                  <Numeral value="18000" format="0,0.00" style="font-weight: 600;">
                      <template #prefix>
                          <strong>¥</strong>
                      </template>
                  </Numeral>/CPU
                </Paragraph>
                <Paragraph>
                  <Text>高可用集群版本，含完整的虚拟化和集群和高可用的功能授权，可以纳管标准版和三合一版的超融合节点</Text>
                </Paragraph>
              </Typography>
            </Card>
          </Col>
      </Row>
    </div>
</template>

<script>
import Header from '@/components/Header.vue'
import HeaderSec from '@/components/HeaderSec.vue'
import RPrice from '@/http/Price.js'
export default {
  name: 'Blueiaas',
  components: {
    Header,
    HeaderSec
  },
  setup() {
  },
  data(){
    return {
      BreadcrumbList: [
            {
                title: '首页',
                to: '/'
            },
            {
                title: '云与基础设施',
            }
        ],
      Price: {
        /** 256GB, 512GB */
        "LX5-HL101": [ 0, 0],
        "LX5-HS101": [ 0, 0],
        "LX5-HP101": [ 0, 0],
        "LX5-HL302": [ 0, 0],
        "LX5-HS302": [ 0, 0],
        "LX5-HP302": [ 0, 0],
        "LX5-HL303": [ 0, 0],
        "LX5-HS303": [ 0, 0],
        "LX5-HP303": [ 0, 0],
        "LX5-ML021": [0, 0],
        "LX5-ML022": [0, 0],
        "LX5-ML023": [0, 0],
        "LX5-MP022": [0, 0],
      },
    }
  },
  methods: {
    handleClick() {
      this.$Message.info('Welcome to View UI Plus Demo!')
    }
  },
  mounted () {
    this.Price = RPrice.getPrice();
  }
}
</script>

<style lang="less" scoped>
.list{
  width: 100%;
}
.blueiaas-card{
  background-color:#f2f2f2;
  margin-top: 20px;
}
@media (min-width: 1000px) {
  .list{
    width: 1600px;
  }
  .blueiaas-card{
    background-color:#f2f2f2;
    margin-top: 20px;
  }
}
</style>
